// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_mr7","cls2":"LettersModal-cls2_9nz LettersModal-cls1_mr7"};